const TOOLTIP_MAX_WIDTH = 320;
const TOOLTIP_MIN_HEIGHT = 64;
export function calculateTooltipPosition(tooltipEl, wrapper, cursorPosition) {
    let [tooltipLeft, tooltipTop] = cursorPosition;
    let tooltipRight = null;
    let tooltipBottom = null;
    const tooltipRect = tooltipEl.getBoundingClientRect();
    const wrapperRect = wrapper.getBoundingClientRect();
    const tooltipWidth = tooltipRect.width || TOOLTIP_MAX_WIDTH;
    const tooltipHeight = tooltipRect.height || TOOLTIP_MIN_HEIGHT;
    const isRightOverflow = tooltipWidth + tooltipLeft > wrapperRect.right;
    const isBottomOverflow = tooltipHeight + tooltipTop > wrapperRect.bottom;
    if (isRightOverflow) {
        tooltipLeft = null;
        tooltipRight = window.innerWidth - cursorPosition[0];
    }
    if (isBottomOverflow) {
        tooltipTop = null;
        tooltipBottom = window.innerHeight - cursorPosition[1];
    }
    return {
        top: tooltipTop,
        left: tooltipLeft,
        bottom: tooltipBottom,
        right: tooltipRight,
    };
}
//# sourceMappingURL=tooltip.js.map